import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { DEFAULT_SEND_WINDOWS, SendWindow, isInWindow } from 'src/app/models/SendWindow';

let instanceCounter = 0;

/**
 * "Enviar agora" × "Agendar para data e hora" (M8 / CU-17tm466nzee,
 * m8-comum.md): "Enviar agora" fica desabilitado fora da janela de envio,
 * reavaliado a cada 30s (a janela pode abrir/fechar com a página aberta).
 * O(s) seletor(es) de data+hora entram via `<ng-content>` — o m8-voz encaixa
 * Início/Fim de uma campanha de ligação dentro do mesmo wrapper.
 */
@Component({
  selector: 'app-send-when',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './send-when.component.html',
  styleUrls: ['./send-when.component.scss'],
})
export class SendWhenComponent implements OnInit, OnDestroy {
  @Input() window: SendWindow = DEFAULT_SEND_WINDOWS.sms;
  @Input() sendNow = true;
  @Input() testId?: string;

  @Output() sendNowChange = new EventEmitter<boolean>();

  readonly radioName = `send-when-${++instanceCounter}`;
  nowInWindow = true;

  private timer?: ReturnType<typeof setInterval>;

  ngOnInit(): void {
    // Calcula `nowInWindow` já na montagem (o `[disabled]` do rádio precisa dele
    // certo no primeiro render), mas sem emitir `sendNowChange` ainda: emitir
    // dentro do próprio `ngOnInit` corrige o pai na MESMA leva de change detection
    // que já renderizou o valor antigo, e o Angular (em modo estrito, como nos
    // testes) acusa `ExpressionChangedAfterItHasBeenCheckedError`. A correção de
    // "Enviar agora" fora da janela acontece no próximo tick (ainda antes de
    // qualquer interação do usuário) e depois a cada 30s.
    this.nowInWindow = isInWindow(this.window);
    setTimeout(() => this.refresh());
    this.timer = setInterval(() => this.refresh(), 30_000);
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  select(sendNow: boolean): void {
    if (sendNow && !this.nowInWindow) {
      return;
    }
    if (this.sendNow === sendNow) {
      return;
    }
    this.sendNow = sendNow;
    this.sendNowChange.emit(sendNow);
  }

  private refresh(): void {
    this.nowInWindow = isInWindow(this.window);

    // A janela fechou com "Enviar agora" selecionado (página aberta na virada):
    // não deixa um rádio desabilitado E marcado — passa para "Agendar".
    if (!this.nowInWindow && this.sendNow) {
      this.sendNow = false;
      this.sendNowChange.emit(false);
    }
  }
}
